import './CategoryEditBlocks.scss';
import { ResponsiveGrid } from '@gplibraries/react/components';
import SubcategoryEditBlock from './SubcategoryEditBlock.jsx';

export default function CategoryEditBlock(props) {

  const { categories, dispatch } = props;

  return (
    <ResponsiveGrid
      className="fill categories-wrapper"
      minColumnWidth={'400px'}
      gap={'3rem'}
    >
      {categories
        .filter(cat => !cat.parent)
        .sort((a, b) => a.weight - b.weight)
        .map(category =>
          <SubcategoryEditBlock
            key={category.id}
            category={category}
            subcategories={
              categories
                .filter(subcategory => subcategory.parent?.id === category.id)
                .sort((a, b) => a.weight - b.weight)
            }
            dispatch={dispatch}
          />
        )
      }
    </ResponsiveGrid>
  );
}